
<gw-findings-table [findingsStatus]="'not_assigned'"></gw-findings-table>